<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j0YJiz/tc-custom/9781467451376.jpg?1730407466428" alt="This image is the cover for the book Religious Liberty, Volume 5, Emory University Studies in Law and Religion (EUSLR)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Religious Liberty, Volume 5, Emory University Studies in Law and Religion (EUSLR)
      </h1>
      <p class="bookDescription body article font2">
        <p>One of the most respected and influential scholars of religious liberty in our time, Douglas Laycock has argued many crucial religious-liberty cases in the United States Supreme Court. His noteworthy scholarly and popular writings are being collected in five comprehensive volumes under the title <i>Religious Liberty.</i></p><p>In this final volume Laycock documents the use of the Constitu­tion’s Free Speech Clause and Establishment Clause in legal briefs, scholarly and popular articles, House testimonies, and written debates. These two clauses have been vitally important in religious-liberty cases concerning religious speech in schools, politics, and the workplace, government funding of religious schools and social services, and the meaning of separation of church and state.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas Laycock
      </h2>
      
      <p class="authorDescription body article"> &#160; <B>Douglas Laycock</B>&#160;is Robert E. Scott Distinguished Professor of Law and professor of religious studies at the University of Virginia. In addition to his work as a lawyer, he has written for the&#160;<I>New York Times</I>, the&#160;<I>Washington Post</I>, and numerous other publications. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?307041a9